import { Box } from "@mui/material";
import { ReactNode } from "react";

import { useOverflowDetector } from "../../../hooks";

export interface Props {
  children: ReactNode;
}

/**
 * The css text-overflow: ellipsis property does not work well (at all)
 * for complex inline text elements. This somewhat emulates the behavior
 * by showing a '...' continuation when the children overflow, and adding
 * a gradient mask, to soften the unavoidably displayed partially overflowed
 * children.
 */
export default function FakeEllipsisOverflow({ children }: Props) {
  const { ref, overflow: isOverflowed } = useOverflowDetector<HTMLDivElement>();

  return (
    <Box
      sx={{
        position: "relative",

        "&::after": {
          content: isOverflowed ? '"..."' : '""',
          position: "absolute",
          top: "0.2em",
          right: 0,
          transform: "translateX(-100%)",
        },
      }}
    >
      <Box
        ref={ref}
        style={{
          maskImage: isOverflowed
            ? // fade out the right-hand side of the container to make room for the '...'
              "linear-gradient(to right, black calc(100% - 4em), transparent calc(100% - 2em))"
            : undefined,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
